module.exports = __webpack_public_path__ + "img/top-list-left4.d9ab1605.png";